export default class RenvoieResult {
  id
  data
  customData
  doublons

  constructor(id = 0, data = [], customData = [], doublons = []) {
    this.id = id
    this.data = data
    this.customData = customData
    this.doublons = doublons
  }

  static NULL = new RenvoieResult()
}

export class RenvoieResultData {
  component
  id
  value
  data

  constructor(component, id, value, data) {
    this.component = component
    this.id = id
    this.value = value
    this.data = data
  }
}

export class RenvoieValues {
  ids
  role
  component = ''
  idcc
  theme
  values

  constructor(role, component = '', idcc, theme, ids = {}, values = {}) {
    this.role = role
    this.component = component
    this.idcc = idcc
    this.theme = theme
    this.ids = ids
    this.values = values
  }
}
